import axios from 'axios';
import { getPresignedUrl } from '@gtintel/platform-api';
export const uploadFileToPresignedUrl = async (file, objectId, type, path) => {
  const resp = await getPresignedUrl({
    type: type,
    id: objectId,
    filename: file.name,
    fileType: file.type,
    path: path
  });
  const formData = new FormData();
  for (const key in resp.presigned.fields) {
    formData.append(key, resp.presigned.fields[key]);
  }
  formData.append('file', file);
  try {
    await axios.post(resp.presigned.url, formData);
  } catch (e) {
    console.error(`Request failed with: ${e}`);
    return Promise.reject(e);
  }
  return resp;
};